import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";

export interface DatepickerModel {
  date: Date;
  dates?: Date[];
  dayLabels?: string[];
}

export interface Date {
  value: string;
  momentDate?: any;
  day: string;
  month: string;
  year: string;
  active?: boolean;
  disabled?: boolean;
  isValid?: boolean;
}

export interface ViewDate {
  value: string;
  month: string;
  monthString: string;
  year: string;
}

export interface DatePickerOptions {
  minDate?: string;
  maxDate?: string;
  readonly?: boolean;
  autoFillOnClear?: boolean;
  markDisabledRules?: (date: NgbDateStruct) => boolean;
}

export type outsideDaysType = 'visible' | 'collapsed' | 'hidden';

export interface DateObject {
  day?: number;
  month: number;
  year: number;
}

export enum DropdownType {
  Month = 'dropdownMonth',
  Year = 'dropdownYear'
}
